(() => {
  if (window.__HC_THEME_R26_LOADED__) return;
  window.__HC_THEME_R26_LOADED__ = true;

  const hiddenCollectionValues = new Set([
    'graded pokemon cards',
    'graded yugioh cards',
  ]);

  const normalizeLabel = (value) =>
    (value || '')
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/\([^)]*\)\s*$/, '')
      .replace(/[^a-z0-9]+/gi, ' ')
      .trim()
      .toLowerCase();

  const matchesExactRedundantCollectionLabel = (value) => {
    const normalizedValue = normalizeLabel(value);
    if (!normalizedValue) return false;

    return [...hiddenCollectionValues].some((hiddenValue) => normalizedValue === hiddenValue)
      || /^graded (?:pokemon|yu gi oh|yugioh) cards?$/.test(normalizedValue);
  };

  const matchesRedundantCollectionAttribute = (value) => {
    const normalizedValue = normalizeLabel(value);
    if (!normalizedValue) return false;

    return matchesExactRedundantCollectionLabel(normalizedValue)
      || [...hiddenCollectionValues].some((hiddenValue) => normalizedValue.includes(hiddenValue))
      || /\bgraded (?:pokemon|yu gi oh|yugioh) cards?\b/.test(normalizedValue);
  };

  const filterRootsSelector = [
    '.gf-filter-contents',
    '.gf-filter-left',
    '.gf-filter-sidebar',
    '#gf-tree',
    '[class*="globo-filter"]',
  ].join(',');

  const optionRowSelector = [
    'li',
    'label',
    'a',
    '.gf-option-box',
    '.gf-option-item',
    '.gf-option-row',
    '.gf-attribute',
    '[class*="option-box"]',
    '[class*="option-item"]',
    '[class*="filter-item"]',
  ].join(',');

  const elementMatchesHiddenFilter = (element) => {
    if (matchesExactRedundantCollectionLabel(element.textContent)) return true;

    const attributeValues = [
      element.getAttribute('value'),
      element.getAttribute('data-value'),
      element.getAttribute('data-filter-value'),
      element.getAttribute('data-name'),
      element.getAttribute('data-title'),
      element.getAttribute('aria-label'),
      element.getAttribute('title'),
      element.getAttribute('href'),
    ];

    return attributeValues.some(matchesRedundantCollectionAttribute);
  };

  const hideRedundantOptionsInRoot = (filterRoot) => {
    filterRoot.querySelectorAll(optionRowSelector).forEach((element) => {
      if (element.dataset.hcHiddenFilter === 'true') return;
      if (!elementMatchesHiddenFilter(element)) return;

      const option = element.closest(optionRowSelector) || element;
      option.hidden = true;
      option.setAttribute('aria-hidden', 'true');
      option.setAttribute('data-hc-hidden-filter', 'true');
      option.style.setProperty('display', 'none', 'important');
    });
  };

  const hideRedundantCollectionFilters = (scope = document) => {
    const roots = [];
    if (scope instanceof Element && scope.matches(filterRootsSelector)) roots.push(scope);
    if (scope.querySelectorAll) roots.push(...scope.querySelectorAll(filterRootsSelector));
    roots.forEach(hideRedundantOptionsInRoot);
  };

  const setupCarousel = (carousel) => {
    if (carousel.dataset.hcCarouselReady === 'true') return;
    carousel.dataset.hcCarouselReady = 'true';

    const track = carousel.querySelector('[data-hc-carousel-track]');
    const previous = carousel.querySelector('[data-hc-carousel-previous]');
    const next = carousel.querySelector('[data-hc-carousel-next]');
    if (!track || !previous || !next) return;

    const updateButtons = () => {
      const maxScroll = Math.max(0, track.scrollWidth - track.clientWidth);
      previous.disabled = track.scrollLeft <= 2;
      next.disabled = track.scrollLeft >= maxScroll - 2;
    };

    const scrollByPage = (direction) => {
      track.scrollBy({ left: direction * Math.max(240, track.clientWidth * 0.82), behavior: 'smooth' });
    };

    previous.addEventListener('click', () => scrollByPage(-1));
    next.addEventListener('click', () => scrollByPage(1));
    track.addEventListener('scroll', updateButtons, { passive: true });
    window.addEventListener('resize', updateButtons, { passive: true });
    requestAnimationFrame(updateButtons);
  };

  const initialize = (root = document) => {
    hideRedundantCollectionFilters(root);
    root.querySelectorAll?.('[data-hc-product-carousel]').forEach(setupCarousel);
  };

  let mutationFrame = 0;
  const filterObserver = new MutationObserver((mutations) => {
    if (mutationFrame) return;
    mutationFrame = requestAnimationFrame(() => {
      mutationFrame = 0;
      mutations.forEach((mutation) => {
        mutation.addedNodes.forEach((node) => {
          if (node instanceof Element) hideRedundantCollectionFilters(node);
        });
      });
    });
  });

  const start = () => {
    initialize();
    filterObserver.observe(document.body, { childList: true, subtree: true });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }

  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
})();
